import gql from 'graphql-tag'

// shouldn't do it this way but :shrug:
import { projectListValues } from 'app/libreon/Project/graphql'

export const publicUserListVars = `
  id
  handle
  name
  avatar
  verified
  lastSeen
`

export const publicUserValues = `
  ${publicUserListVars}
  tags {
    id
    type
    public
    meta
    tag {
      id
      label
      meta
    }
  }
  updatedAt
  insertedAt
  data { id type value }
`

const emailValues = 'id,address,primary,verified'
export const userValues = `
  ${publicUserValues}
  emails {${emailValues}}
  phones {id,number,primary,verified}
  settings
  access { roles, actions }
  authStatus
  data { id type value }
`

export const NOTIFY_PREFS = gql`
  query notifyPrefs($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        notifyPrefs {
          id
          type
          pref
          allow
          updatedAt
        }
      }
    }
  }
`

export const SET_NOTIFY_PREF = gql`
  mutation upsertNotifyUserPref($pref: InputNotifyUserPref!, $id: UUID!) {
    upsertNotifyUserPref(pref: $pref, id: $id) {
      success
      reason
      result {
        id
        type
        pref
        allow
      }
    }
  }
`

export const LOAD_USER = gql`
query loadUser($id: ShortId!) {
  users(id: $id) {
    success
    reason
    result {
      ${userValues}
    }
  }
}
`
// journeyActor {
//   id
//   journeyMaps {
//     id
//     journey {
//       id
//       name
//     }
//   }
// }

export const publicUserListProj =
  'projects { id type project { id shortId title format } }'

export const PUBLIC_USER_LIST = gql`
  query publicUsers($filter: UserFilter) {
    publicUsers(filter: $filter) {
      success
      reason
      results {
        ${publicUserListVars}
      }
    }
  }
`
// export const LIST_PUBLIC_USERS = gql`
// query publicUsers($filter: UserFilter!) {
//   publicUsers(filter: $filter) {
//     success
//     reason
//     total
//     result {
//       ${publicUserValues}
//     }
//   }
// }
// `

export const PUBLIC_USER = gql`
  query publicUser($id: ShortId!) {
    publicUser(id: $id) {
      success
      reason
      result {
        ${publicUserValues}
        ${publicUserListProj}
      }
    }
  }
`

export const LOAD_PUBLIC_USER = gql`
  query publicUser($id: ShortId) {
    publicUser(id: $id) {
      success
      reason
      result {
        ${publicUserValues}
        projects {
          id
          type
          project {
            ${projectListValues}
          }
        }
      }
    }
  }
`
// journeys {
//   id
// }

export const UPDATE_USER = gql`
mutation updateUser(
    $id: ShortId, $action: ChangeActions,
    $user: InputUser, $handle: InputHandle, $email: InputEmail,
    $phone: InputPhone, $data: InputData, $role: InputRole)
  {
    updateUser(
      id: $id, action: $action,
      user: $user, handle: $handle, email: $email,
      phone: $phone, data: $data, role: $role)
    {
      success
      reason
      result {
        ${userValues}
      }
    }
  }
`
export const GEN_APIKEY = gql`
  mutation genApiKey {
    genApiKey {
      access
      validation
    }
  }
`

export const GET_INVITES = gql`
  mutation getInvites {
    getInvites {
      codes
    }
  }
`

export const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String, $id: ShortId) {
    requestPasswordReset(email: $email, id: $id) {
      success
      reason
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation changePassword($current: String, $new: String!, $code: String) {
    changePassword(current: $current, new: $new, code: $code) {
      success
      reason
    }
  }
`

export const MY_FACTORS = gql`
  query myFactors($type: String, $id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        emails {${emailValues}}
        factors(type: $type) {
          id
          type
          expiresAt
        }
      }
    }
  }
`

export const GET_ACCESS = gql`
  query getAccess($type: AccessDomain!, $refId: UUID!) {
    getAccess(type: $type, refId: $refId)
  }
`

export const inviteValues = `
  id
  shortId
  expiresAt
  requestorId
  requestType
  targetType
  requestAccess
  resourceType
  resourceId
  projectId
  orgId
  email
  targetId
  note
  target {
    ${publicUserValues}
    id
    name
    handle
  }
`

export const INVITE = gql`
  mutation invite(
    $action: InviteAction!
    $targetType: InviteTargetType
    $requestType: InviteRequestType
    $requestAccess: InviteAccessType
    $responseType: InviteResponseType
    $responseAccess: InviteAccessType
    $resourceType: InviteResourceType
    $resourceId: UUID
    $projectId: UUID
    $targetId: UUID
    $orgId: UUID
    $note: String
    $email: String
    $shortId: UUID
  ) {
    invite(
      action: $action
      targetType: $targetType
      requestType: $requestType
      requestAccess: $requestAccess
      responseType: $responseType
      responseAccess: $responseAccess
      resourceType: $resourceType
      resourceId: $resourceId
      targetId: $targetId
      projectId: $projectId
      orgId: $orgId
      note: $note
      email: $email
      shortId: $shortId
    ) {
      success
      reason
      result {
        id
        shortId
        expiresAt
      }
    }
  }
`

export const DELETE_ACCOUNT = gql`
  mutation deleteAccount($code: String) {
    deleteAccount(code: $code) {
      success
      reason
    }
  }
`
